// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://4icufyt7jjcp3am5zrwqbgduwu.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-a4yvpjs2zzfx3eog6o7mn55yre",
    "aws_content_delivery_bucket": "ndc-20190929231929-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d3996bnwxoeypp.cloudfront.net"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js